import React from 'react';
import RouteViewPage from "../Pages/route-view-page";
import {useParams} from "react-router-dom"
import { LinearProgress } from '@mui/material';
import GetEvent from "../Drive/get-event";

function Cleanup() {
    const data_sheet_id = '1uXVwCslp65pxkg5KRWcIQDz47S0tkeJIzOeKeXryyY8';
    const data_csv_url = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vS30UtxHTQwa9vXpWErpzQz3WrTwHrMNoV7YcPYlCNL6HEUMVmeJJFHmODCg_zuEUAR7cFIAKJsrqHh/pub?output=csv';
    const script_id = "AKfycbw0h496IMtDZQjFHY0W6jqM-aqdL4F7T36k_2t4zUCgvIW3qGumGZP5V2wv2JffbXHxmg";
    // ACTION: Change to this path requires update to public cleanup routes sheet getImages script
    const base_image_upload_path = '/uploads/${event}/cleanups/properties/';
    const [image_upload_path, setImageUploadPath] = React.useState("");

    React.useEffect(() => {
        GetEvent(script_id, handleUpdateEvent)
    }, [])

    const handleUpdateEvent = (result) => {
        if (result.succeeded) {
            let newPath = base_image_upload_path.replace("${event}", result.event)
            setImageUploadPath(newPath);
        }
    }

    let params = useParams();
    let id = params.id.replaceAll("_", " ");

    return (
        <>
        {image_upload_path == "" ? (
            <LinearProgress />
        ):(
            <RouteViewPage id={id} data_sheet_id={data_sheet_id} data_csv_url={data_csv_url} script_id={script_id} image_upload_path={image_upload_path}/>
        )}
        </>
        
    )
}

export default Cleanup

